import {LanguageItemTypes} from 'appRedux/actions/admin/types';
import {ResourceFieldCalendarTemplateTypes} from 'appRedux/actions/resourceFields/types';

export const getLanguagesWithoutCalendarTemplate = (
    languageList: LanguageItemTypes[],
    templates: ResourceFieldCalendarTemplateTypes[],
): number[] => {
    const results: number[] = [];
    languageList.forEach(language => {
        const currentLanguageTemplatePresented = templates.some(item => item.language === language.id);
        if (!currentLanguageTemplatePresented) {
            results.push(language.id);
        }
    });
    return results;
};
